import reducer from "./reducers";

import * as componentAction from "./actions";

export { componentAction };

export default reducer;
